import { z } from "zod";
import { PersonIdSchema } from "./branded-id.schemas.js";
import {
  EventParticipantRosterEntrySchema,
  type EventParticipantRoster,
} from "./event-participant-roster.schemas.js";

/**
 * Admin tier of `GET /api/v1/events/:eventIdPublic/participants/roster`: the
 * generic roster row plus the fields only an admin may see. Deliberately thin —
 * enough to list, search and select. Anything a view needs beyond that is that
 * view's own read.
 */
export const AdminEventParticipantSchema =
  EventParticipantRosterEntrySchema.extend({
    // The participant's internal id as a plain string. Carried alongside the
    // public id for consumers that key people by it (matching-engine pools do),
    // so they cross-reference the roster without a translation map.
    personId: PersonIdSchema,
    primaryEmail: z.string().nullable(),
    primaryPhone: z.string().nullable(),
  });

export const AdminEventParticipantRosterSchema = z.object({
  participants: z.array(AdminEventParticipantSchema),
});

export type AdminEventParticipant = z.infer<typeof AdminEventParticipantSchema>;
export type AdminEventParticipantRoster = z.infer<
  typeof AdminEventParticipantRosterSchema
>;

/**
 * Both tiers of `GET /api/v1/events/:eventIdPublic/participants/roster` read
 * the same rows; which schema encodes the response is decided by the actor's
 * role, not the route.
 */
export type EventParticipantRosterResult =
  | AdminEventParticipantRoster
  | EventParticipantRoster;
